import { memo, useEffect, useState } from 'react'

import { keepPreviousData } from '@tanstack/react-query'

import { LoadingLottie, OverlayLoading } from '@/components/loading'
import { EmptyState } from '@/components/ui/Empty'
import { Pagination } from '@/components/ui/pagination'
import RenderIf from '@/components/ui/render-if'
import { Text } from '@/components/ui/text'
import { ViewportContent, ViewportContentWrapper } from '@/components/ui/viewport-fit'
import { useQueryReferralStatistics } from '@/data/referral'
import CommonPeer from '@/icons/icons/CommonPeer'
import { useReferralWallet } from '@/store'

import { isEmpty } from 'lodash-es'
import { useTranslation } from 'react-i18next'

import { History } from './History'

const DEFAULT_PAGE_STATE = {
  page: 1,
  pageSize: 20,
}
export const ReferralHistory = memo(() => {
  const { t } = useTranslation()
  const referralWallet = useReferralWallet()
  const [pageState, setPageState] = useState(DEFAULT_PAGE_STATE)
  const {
    data: referralStatistics,
    isLoading,
    isFetching,
  } = useQueryReferralStatistics(
    {
      walletAddress: referralWallet?.address || '',
      page: pageState.page,
      limit: pageState.pageSize,
    },
    {
      placeholderData: keepPreviousData,
    }
  )

  useEffect(() => {
    setPageState(DEFAULT_PAGE_STATE)
  }, [referralWallet?.address])

  const total = referralStatistics?.paging?.total || 0
  const renderContent = () => {
    if (isLoading)
      return (
        <div className='flex justify-center items-center h-full'>
          <LoadingLottie className='size-6' />
        </div>
      )
    if (isEmpty(referralStatistics?.data?.referrals))
      return (
        <EmptyState
          title={t('title.NO_ONE_INVITED')}
          description={t('title.START_INVITING')}
          icon={<CommonPeer className='size-12' />}
          className='pb-10'
        />
      )
    return <History referrals={referralStatistics?.data?.referrals} />
  }
  return (
    <ViewportContentWrapper
      className='relative w-full bg-black-100 dark:bg-white-4 rounded-sm px-5 md:px-6 py-5 md:pt-8 '
      style={{
        alignItems: 'normal',
      }}
    >
      <div className='flex mb-3 pl-2 flex-1 items-center justify-between'>
        <Text size={22}>{t('title.REFERRALS')}</Text>
        {/* <Filters /> */}
      </div>
      <ViewportContent>
        {renderContent()}
        <OverlayLoading isVisible={isFetching && !isLoading} className='top-0' />
      </ViewportContent>
      <RenderIf condition={total > DEFAULT_PAGE_STATE.pageSize}>
        <div className='mt-5 pt-5 border-t-[0.5px] border-white-10'>
          <Pagination
            page={pageState.page}
            total={total}
            pageSize={pageState.pageSize}
            onPageChange={(page) => setPageState({ ...pageState, page: page })}
            onPageSizeChange={(pageSize) => setPageState({ page: DEFAULT_PAGE_STATE.page, pageSize: pageSize })}
            className='border-t border-white-10'
            pageContentClassName='justify-center md:justify-end flex-1'
          />
        </div>
      </RenderIf>
    </ViewportContentWrapper>
  )
})
